import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IonTextarea } from '@ionic/angular';
import { Answer, Question } from '@haleo-frontend/data-access/models';

@Component({
    selector: 'app-thought-record-question-text-list',
    templateUrl: 'text-list.component.html',
    styleUrls: ['text-list.component.scss']
})
export class TextListComponent implements OnChanges {

    @ViewChild('textarea') textarea: IonTextarea;
    @Input() question: Question;
    @Input() answer: Answer | undefined;
    @Input() thought: string | null;
    @Input() thoughtIndex: number;
    @Input() thoughtTotal: number;
    @Input() readOnly: boolean;
    @Output() answered: EventEmitter<any>;

    value: string;
    texts: string[];
    textsMulti: string[][];
    placeHolder: string;
    addElementBtnText: string;
    showTextarea: boolean;
    guided: boolean;
    guideSteps: string[];
    showIntro: boolean;
    challengeThoughts: boolean;

    constructor() {
        this.answered = new EventEmitter<any>();
    }

    ngOnChanges(changes: SimpleChanges): void {

        this.value = '';
        this.addElementBtnText = 'thoughtRecord.assessment.addThought';

        if (this.question) {

            this.placeHolder = '';
            this.guideSteps = [];

            if (this.question.options && this.question.options.length > 0) {

                const data = JSON.parse(this.question.options);

                if (data && data.placeHolder) {
                    this.placeHolder = data.placeHolder;
                }

                if (data && data.addBtn) {
                    this.addElementBtnText = data.addBtn;
                }

                this.guideSteps = data.guide;
            }
        }

        this.challengeThoughts = this.question && this.question.key === 'TR_Challenge_Thoughts';

        if (this.challengeThoughts) {

            if (this.answer) {
                this.textsMulti = JSON.parse(this.answer.value);
                this.texts = this.textsMulti[this.thoughtIndex] ? this.textsMulti[this.thoughtIndex] : [];
            } else {
                this.texts = [];
                this.textsMulti = [];
            }
        } else {

            if (this.answer) {
                this.texts = JSON.parse(this.answer.value);

                // Multi text case in view mode
                if (this.readOnly && this.texts.length > 0 && typeof this.texts[0] === 'object') {

                    const texts: any = [];
                    this.texts.forEach(textArray => texts.push(...textArray));
                    this.texts = texts;
                }

            } else {
                this.texts = [];
            }
        }

        this.showIntro = this.question && this.question.key === 'TR_Alternative_Interpretation';
        this.showTextarea = this.texts.length === 0;
    }

    addText() {
        this.texts.push(this.value);
        this.value = '';
        this.showTextarea = false;
    }

    newText() {
        this.showTextarea = true;
        setTimeout(() => {
            this.textarea.setFocus();
            document.getElementById('bottom')?.scrollIntoView({behavior: 'smooth'});
        }, 0);
    }

    removeText(index: number) {
        this.texts.splice(index, 1);
    }

    continue() {

        if (this.question && this.question.key === 'TR_Challenge_Thoughts') {
            this.textsMulti[this.thoughtIndex] = this.texts;
            this.answered.emit(JSON.stringify(this.textsMulti));
        } else {
            this.answered.emit(JSON.stringify(this.texts));
        }
    }

    guidedAnswered(texts: any) {
        this.texts = this.texts.concat(texts);
        this.guided = false;
    }
}
